import { useMemo, useState } from "react";
import { STORAGE } from "../constants";
import { LocalStorageService } from "../services/LocalStorageService";

export const useSession = () => {

    const [session] = useState(LocalStorageService.get(STORAGE.SESSION))

    const roleSession = useMemo(
      () => {
        return session?.profile ? session?.profile.toLowerCase(): '';
      },
      [],
    )
    
    return {
      session,
      roleSession
    }
}